
const IconDeleteDB = ({size = 180} : {size: number}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Icons"
    height={size}
    width={size}
    viewBox="0 0 32 32"
  >
    <style>
      {
        ".st0{fill:none;stroke:#000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"
      }
    </style>
    <ellipse cx={14} cy={8} rx={11} ry={6} />
    <path d="M14 24c-4.8 0-8.8-1.4-11-3.6V24c0 3.4 4.8 6 11 6 .9 0 1.8-.1 2.7-.2-1.5-1.5-2.4-3.6-2.7-5.8zM3 12.4V16c0 3.4 4.8 6 11 6h.1c.2-2.4 1.4-4.6 3-6.2-1 .1-2 .2-3.1.2-4.8 0-8.8-1.4-11-3.6zM18.3 17.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0 3.1-8.2 0-11.3-8.1-3.1-11.3 0zm8.5 4.3L25.4 23l1.4 1.4c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L24 24.4l-1.4 1.4c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l1.4-1.4-1.4-1.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.4 1.4 1.4-1.4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z" />
  </svg>
)
export default IconDeleteDB;
